import { css } from '@/styled-system/css';

// Base scrollbar configuration (shared styles)
const baseScrollbarConfig = {
  '&::-webkit-scrollbar': {
    WebkitAppearance: 'none',
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '300',
  },
} as const;

// Always visible scrollbar
export const scrollbarStyles = css.raw({
  ...baseScrollbarConfig,
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '300',
    backgroundColor: 'var(--colors-bg-soft)',
  },
});

// Hover-only scrollbar
export const scrollbarHoverStyles = css.raw({
  ...baseScrollbarConfig,
  scrollbarColor: 'transparent transparent',
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '300',
    backgroundColor: 'transparent',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'var(--colors-bg-soft)',
  },
  '&:hover': {
    scrollbarColor: 'var(--colors-bg-soft) transparent',
  },
});
